import leafWebp from "@/assets/logo-leaf.webp";
import leafPng from "@/assets/logo-leaf.png";

interface Props {
  size?: "sm" | "md";
  className?: string;
}

const Logo = ({ size = "md", className = "" }: Props) => {
  const iconSize = size === "sm" ? "h-7 w-7" : "h-9 w-9";
  const textSize = size === "sm" ? "text-base" : "text-lg";
  const scriptSize = size === "sm" ? "text-xs" : "text-sm";

  return (
    <a
      href="/"
      title="Eliza Reed Wellness — home"
      className={`inline-flex items-center gap-3 ${className}`}
    >
      <picture>
        <source type="image/webp" srcSet={leafWebp} />
        <img
          src={leafPng}
          alt=""
          width={512}
          height={512}
          loading="lazy"
          className={`${iconSize} object-contain`}
        />
      </picture>
      <span className="flex flex-col leading-tight text-left">
        <span className={`font-serif ${textSize} text-foreground`}>
          Eliza Reed
        </span>
        <span className={`font-script ${scriptSize} text-primary`}>
          Wellness
        </span>
      </span>
    </a>
  );
};

export default Logo;
